<script setup>
import moment from 'moment';
import { ElText } from "element-plus";

const props = defineProps({
    flight: Object
});

const flight = props.flight;

const momenttime = (date) => {
    return moment(date).format('HH:mm');
};

const momentdate = (date) => {
    return moment(date).format('ddd, D MMM');
};

const formatdate = (date) => {
    return moment(date, "YYYY-MM-DD").format("dddd, MMM D");
};

const mintoHM = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return hours + "h " + minutes + "m ";
};

const airlineLogoUrl = (airline) => {
    if (airline && airline.logo) {
        return airline.logo;
    }
    return '';
};
</script>

<template>
    <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="detailhdr">
                <div>
                    <h2 class="fromtotitle">{{ flight.from.city }} → {{ flight.to.city }}</h2>
                    <p class="details">
                        <span class="scheduleday">{{ formatdate(flight.departure_datetime) }}</span>
                        <span class="stops">{{ flight.stops > 0 ? flight.stops + " stop" : "Non Stop" }} · {{ mintoHM(flight.duration) }}</span>
                    </p>
                </div>
            </div>

            <div class="flightItenaryContainer">
                <el-row v-for="(subflight, index) in flight.flights" :key="index">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-row class="sub-fli-details">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="airline-details">
                                    <img
                                        v-if="airlineLogoUrl(subflight.airline)"
                                        :src="airlineLogoUrl(subflight.airline)"
                                        alt=""
                                        style="height: 28px; width: auto; max-width: 48px; object-fit: contain;"
                                    >
                                    <span class="airline-names">{{ subflight.airline.name }}</span> |
                                    <span class="fliCode">{{ subflight.flight_code }}</span>
                                </div>
                            </el-col>

                            <el-col class="pt-2 pb-2 text-right" :xs="8" :sm="8" :md="5" :lg="5" :xl="5">
                                <div class="ftime">{{ momenttime(subflight.departure_datetime) }}</div>
                                <div class="fdate">{{ momentdate(subflight.departure_datetime) }}</div>
                                <div class="fcity">{{ subflight.from.city }}, {{ subflight.from.country }}</div>
                                <div class="font12 text-grey">{{ subflight.from.terminal }}</div>
                            </el-col>

                            <el-col class="pt-2 pb-2" :xs="8" :sm="8" :md="4" :lg="4" :xl="4">
                                <div class="fduration">
                                    <p>{{ mintoHM(subflight.duration) }}</p>
                                    <img src="https://flight.easemytrip.com/Content/CSS/NewInternationalCss2/img/flg-p.png">
                                </div>
                            </el-col>

                            <el-col class="pt-2 pb-2 text-left" :xs="8" :sm="8" :md="5" :lg="5" :xl="5">
                                <div class="ftime">{{ momenttime(subflight.arrival_datetime) }}</div>
                                <div class="fdate">{{ momentdate(subflight.arrival_datetime) }}</div>
                                <div class="fcity">{{ subflight.to.city }}, {{ subflight.to.country }}</div>
                                <div class="font12 text-grey">{{ subflight.to.terminal }}</div>
                            </el-col>

                            <el-col class="pt-2 pb-2 text-left" :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
                                <div class="baggage-info" v-if="subflight.baggages">
                                    <p class="title">
                                        <span>BAGGAGE :</span>
                                        <span>CHECK IN</span>
                                        <span>CABIN</span>
                                    </p>
                                    <p class="detail" v-for="(baggage, index) in subflight.baggages" :key="index">
                                        <span>{{ index }}</span>
                                        <span>{{ baggage.checkin }}</span>
                                        <span>{{ baggage.cabin }}</span>
                                    </p>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>

                    <el-col class="layover" v-if="flight.layovers[index]" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-divider>
                            {{ mintoHM(flight.layovers[index].duration) }} Layover
                        </el-divider>
                    </el-col>
                </el-row>
            </div>

            <div class="baggeinfo"></div>
        </el-col>
    </el-row>
</template>

<style scoped>
.detailhdr .fromtotitle {
    float: left;
    background: #636363;
    color: #fff;
    padding: 6px 12px;
    border-radius: 8px 8px 0 0;
    font-weight: 600;
    font-size: 17px;
}

.detailhdr .details {
    width: 100%;
    display: flex;
    margin-top: 5px;
    padding: 9px;
    border: 1px solid #d1d1d1;
    border-bottom: 0px;
}

.detailhdr .scheduleday {
    font-weight: 700;
    margin-right: 10px;
}

.detailhdr .stops {
    border: 1px solid #d1d1d1;
    padding: 1px 10px;
    border-radius: 8px;
    font-size: 11px;
}

.airline-details {
    display: flex;
    gap: 15px;
    align-items: center;
}

.airline-names {
    color: #2a2a2a;
    font-weight: 700;
    font-size: 15px;
}

.fliCode {
    font-size: 12px;
}

.flightItenaryContainer {
    border: 1px solid #d1d1d1;
    padding: 10px;
}

.layover .el-divider__text {
    border: 1px solid #e8e8e8 !important;
    border-radius: 15px !important;
    padding: 3px 27px !important;
    background-color: #f4f4f4 !important;
    font-size: 12px !important;
}

.ftime {
    font-size: 20px;
    color: #080808;
    font-weight: 700;
    line-height: 20px;
}

.fdate {
    font-size: 13px;
    color: #000000;
    font-weight: 500;
}

.fcity {
}

.fduration {
    text-align: center;
    padding: 0px 20px;
    font-size: 12px;
}

.fduration .divider {
    margin: 0px;
}

.baggage-info {
    margin: 0 50px;
}

.baggage-info .title {
    display: flex;
    justify-content: space-between;
    color: #080808;
    font-weight: 700;
}

.baggage-info .detail {
    display: flex;
    justify-content: space-between;
    color: #080808;
    font-size: 10px;
    text-align: center;
}
</style>